"use client";
import { useSyncExternalStore } from "react";
import { readBusinessCookie } from "@/lib/business/businessCookie";

type WorkerAttention = { businessId: string; openResourceCount?: number };
let workers: WorkerAttention[] = [];
const listeners = new Set<() => void>();

/** The app sidebar owns the worker poll; other shell components reuse its result. */
export function publishWorkerSnapshot(next: WorkerAttention[]) {
  workers = next;
  for (const listener of listeners) listener();
}
function subscribe(listener: () => void) {
  listeners.add(listener);
  window.addEventListener("caw:activity-refresh", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("caw:activity-refresh", listener);
  };
}
function getAttention() {
  const businessId = readBusinessCookie();
  return workers
    .filter((worker) => worker.businessId === businessId)
    .reduce((total, worker) => total + (worker.openResourceCount ?? 0), 0);
}
export function useWorkerAttention() {
  return useSyncExternalStore(subscribe, getAttention, () => 0);
}
